export default __webpack_public_path__ + "static/media/F_sound.652cc81d.mp3";